<template>
  <div class="container_box details_box_styles">

    <Tabs v-model="useTabValue" @on-click="onTabClick">
      <TabPane v-for="item in tabList" :label="item[languagesVal+'_name']" :name="item.sectorId"></TabPane>
    </Tabs>

    <div class="help_center_box">
      <!--目录-->
      <div class="catalogue_box">
        <Tree
          class="catalogue_box_tree"
          ref="categoryTree"
          :data="catalogueList"
          @on-select-change="selectCatalogue">
        </Tree>
      </div>
      <!--内容-->
      <div class="content_box" v-if="contentTalg">
        <div v-if="addContentTalg">
          <!--返回按钮  未删 稳定后期可删-->
          <div class="flex justify-content-between" style="align-items: flex-start;">
            <div class="go_back" style="margin-bottom: 30px;" @click="cancelBtn">
              <Icon class="back_icon" type="ios-arrow-back"/>
              <span class="back_txt">{{ $t('key1002627') }}</span>
            </div>
            <div class="flex align-items-center">
              <Button class="mr15" @click="cancelBtn">{{ $t('key1000112') }}</Button>
              <Button class="mr15" @click="previewBtn">{{ $t('key1000637') }}</Button>
              <Button type="primary" @click="contentBtn">{{ $t('key1000555') }}</Button>
            </div>
          </div>
          <Form ref="contentInfo" :model="contentInfo" :label-width="80" @submit.native.prevent>
            <languagesTabs ref="formLanguagesTab" @changeLanguagesTabs="changeLanguagesTabs" :tabsList="multilingualNamesList">
              <template v-for="item in multilingualNamesList">
                <template :slot="item.name">
                  <Row type="flex">
                    <Col span="24">
                      <Form-item :label="$t('key1003031')" :prop="'title_' + item.code" :rules="getFormRules(item)">
                        <Input v-model.trim="contentInfo['title_' + item.code]" :placeholder="$t('key1003032')" :element-id="'contentTitle_' + item.code"
                          :maxlength="28" style="width: 400px"></Input>
                        <p style="font-size: 12px; color: #c0bfbf;">{{ $t('key1003037') }}</p>
                      </Form-item>
                    </Col>
                    <Col span="24" class="editor_style">
                      <Form-item :label="$t('key1003033')" prop="content">
                        <UE
                          :disabled="false"
                          :content.sync="contentInfo['content_' + item.code]"
                          :htmlStatus="false"
                          :id="'ueBoxDom_' + item.code"
                          :config="config"
                          :ref="'ueBox_' + item.code">
                        </UE>
                      </Form-item>
                    </Col>
                  </Row>
                </template>
              </template>
            </languagesTabs>
            <Row type="flex">
              <Col span="24">
                <Form-item :label="$t('key1003034')" prop="sort">
                  <InputNumber :max="9999999" :min="1" v-model="contentInfo.sort" :formatter="value => `${parseInt(value)}`"
                    style="width: 100px"></InputNumber>
                  <p style="font-size: 12px; color: #c0bfbf;">{{ $t('key1003038') }}</p>
                </Form-item>
              </Col>
              <Col span="24">
                <Form-item :label="$t('key1003035')" prop="showStatus">
                  <i-switch v-model="contentInfo.showStatus">
                    <template #open>{{ $t('key1003019') }}</template>
                    <template #close>{{ $t('key1003020') }}</template>
                  </i-switch>
                </Form-item>
              </Col>
            </Row>
          </Form>
        </div>
        <div v-else class="wp100">
          <div class="flex wp100">
            <Form class="wp100" ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
              <Row class="wp100">
                <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
                  <Form-item :label="$t('key1003049')" prop="ymsWarehouseId">
                    <Select v-model="pageParams.docsType" filterable>
                      <Option v-for="item in docsTypeList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                    </Select>
                  </Form-item>
                </Col>
                <Col style="min-width: 200px;" class="ml20">
                  <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
                  <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
                </Col>
              </Row>
            </Form>
          </div>

          <Button type="primary" @click="addArticleBtn" class="mb20" :disabled="!getPermission('helpCenterDocs_insert')">{{ $t('key1003039') }}</Button>
          <div class="table_box">
            <Table
              highlight-row
              border
              max-height="600"
              :loading="tableLoading"
              :columns="tableColumns"
              :data="tableData">
              <template #moduleId="{row}">
                <span>{{ getSystemModuleName(row.moduleId) }}</span>
              </template>
              <template #docsType="{row}">
                <span>{{ getEnumName(enumData, 'HelpCenterDocsDocsTypeCoreEnum', row.docsType) }}</span>
              </template>
            </Table>
            <Page
              :transfer="true"
              v-if="!tableLoading"
              :total="total"
              @on-change="changePage"
              show-total
              :page-size="pageParams.pageSize"
              show-elevator
              :current="curPage"
              show-sizer
              @on-page-size-change="changePageSize"
              placement="top"
              :page-size-opts="pageArray">
            </Page>
          </div>
        </div>
      </div>
    </div>
    <!--新增、重命名目录的弹窗-->
    <Modal v-model="catalogueModal" :title="catalogueTitle" width="500" :transfer="false"
      :mask-closable="false" @on-visible-change="catalogueModalChange">
      <Form ref="catalogueForm" :model="catalogueForm" :label-width="120" @submit.native.prevent>
        <Row>
          <languagesTabs ref="languagesTab_catalogue" :tabsList="multilingualNamesList">
            <template v-for="item in multilingualNamesList">
              <template :slot="item.name">
                <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <Form-item :label="labelRander(item)" :prop="'name_' + item.code" :rules="getRules(item)">
                    <Input style="width: 90%;" :placeholder="$t('key1000324')+ item.title +$t('key1003030')" :element-id="'directoryName_' + item.code"
                      clearable v-model.trim="catalogueForm['name_' + item.code]"></Input>
                  </Form-item>
                </Col>
              </template>
            </template>
          </languagesTabs>
        </Row>
      </Form>
      <template #footer>
        <Button @click="catalogueModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="catalogueBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
    <!--复制文章的弹窗-->
    <Modal v-model="copyArticleModal" :title="$t('key1003036')" width="500" :transfer="false"
      :mask-closable="false" @on-visible-change="copyArticleModalChange">
      <Form ref="copyArticleForm" :model="copyArticleForm" :label-width="120" :rules="copyArticleValidate" @submit.native.prevent>
        <Row>
          <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
            <template v-for="item in multilingualNamesList">
              <template :slot="item.name">
                <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <Form-item :label="copyLabelRander(item)" :prop="'copyTitle_' + item.code" :rules="getCopyRules(item)">
                    <Input style="width: 90%;" clearable v-model.trim="copyArticleForm['copyTitle_' + item.code]"></Input>
                  </Form-item>
                </Col>
              </template>
            </template>
          </languagesTabs>
        </Row>
      </Form>
      <template #footer>
        <Button @click="copyArticleModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="copyArticleBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>

    <editHelpDocsModal ref="editHelpDocsModalRef" @updateData="updateData"/>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import UE from '@/components/common/ue';
import languagesTabs from "@/components/common/languagesTabs.vue";
import editHelpDocsModal from "@/views/yms/components/contentManage/editHelpDocsModal.vue";
import {fixCategoryLang, getAllUsersInfo, getDataSetBatchList, getEnumList, getEnumName, getSystemModuleList, getUserNameByUserId} from "@/utils/common";
import supplierMenu from "@/config/menu/supplier";
import ymsMenu from "@/config/menu/yms";
import distributorMenu from "@/config/menu/distributor";

const TREE_NODE_CLASS = 'ivu-tree-children';
const TREE_NODE_HOVER_PREFIX = 'tree-hover-';
const APPEND_BEFORE = 'before';
const APPEND_INNER = 'inner';
const APPEND_AFTER = 'after';
let READY_TO_APPEND = null;
let APPEND_TO = null;
let APPEND_TARGET = null;
let PARENT_DATA = null;

export default {
  name: "helpCenter",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      contentTalg: false,
      total: 0,
      curPage: 1,
      addContentTalg: false,
      pageParams: {
        pageNum: 1,
        pageSize: 15,
        docsType: null,
      },
      contentTypeList: [
        {
          value: 0,
          label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003000')
        },
        {
          value: 1,
          label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003001')
        }
      ],
      systemModuleList: [],
      tableData: [],
      categoryId: null,
      selectId: null,
      contentInfo: {},
      config: { // 富文本编辑器 配置
        initialFrameWidth: null,
        initialFrameHeight: 380,
        serverUrl: api.get_erpCommon_ueditorEnter,
        wordCount: false,
        autoHeightEnabled: false,
        imageScaleEnabled: false
      },
      initFinished: false,
      systemType: 3,
      catalogueList: [],
      catalogueModal: false,
      catalogueType: 'add',
      catalogueTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003022'),
      catalogueForm: {},
      copyArticleValidate: {
        title: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003023'),
            trigger: 'blur'
          }
        ]
      },
      copyArticleModal: false,
      copyArticleForm: {},
      articleTalg: 'add',
      useTabValue: '',
      treeTopId: null,
      level: 0,
      tabList: [],
      labelRander: (params) => {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003024') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424');
      },
      copyLabelRander: (params) => {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003015') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424');
      },
      selectData: null,
      userInfoList: {},
      enumData: [],
      showStatusTalg: false,
      originalColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003005'),
          width: 70,
          key: 'index',
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.sort);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003015'),
          key: 'title',
          minWidth: 230,
          align: 'center',
          render(h, params) {
            let text = '';
            let title = params.row.title;
            let helpDocInternationalList = params.row.docsInternationalQueryResultList || [];
            if (helpDocInternationalList.length > 0) {
              helpDocInternationalList.map((item) => {
                if (item.language === v.languagesVal) {
                  text = item.title;
                }
              });
            }
            return h('span', text ? text : title);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003003'),
          key: 'moduleId',
          slot: 'moduleId',
          minWidth: 110,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003041'),
          key: 'docsType',
          slot: 'docsType',
          minWidth: 110,
          align: 'center',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002969'),
          key: 'viewsQuantity',
          minWidth: 110,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002476'),
          key: 'updatedBy',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            return h('span', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003016'),
          key: 'createdTime',
          align: 'center',
          sortable: true,
          width: 170,
          render(h, params) {
            let time = params.row.createdTime;
            if (time) {
              let date = v.$uDate.getDateTime(params.row.createdTime, 'fulltime');
              return h('span', v.$uDate.getDataToLocalTime(date, 'fulltime'));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003017'),
          key: 'updatedTime',
          align: 'center',
          sortable: true,
          width: 170,
          render(h, params) {
            let time = params.row.updatedTime;
            if (time) {
              let date = v.$uDate.getDateTime(params.row.updatedTime, 'fulltime');
              return h('span', v.$uDate.getDataToLocalTime(date, 'fulltime'));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003042'),
          key: 'showQuantity',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let contentType = '';
            let helpDocInternationalList = params.row.docsInternationalQueryResultList || [];
            if (helpDocInternationalList.length > 0) {
              helpDocInternationalList.map((item) => {
                if (item.language === v.languagesVal) {
                  contentType = item.contentType;
                }
              });
            }
            let obj = v.contentTypeList.find(i => i.value === contentType);
            return h('span', obj ? obj.label : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003043'),
          key: 'showQuantity',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let showStatus = params.row.showStatus === 1;
            return h('i-switch', {
              props: {
                value: showStatus,
                disabled: !v.getPermission('helpCenterDocs_enable') || !v.showStatusTalg
              },
              attrs: {
                title: v.showStatusTalg ? '' : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003044')
              },
              on: {
                'on-change': (val) => {
                  v.updateStatusBtn(params.row, val, 'showStatus');
                }
              }
            }, [h('span', {
              slot: "open",
              domProps: {
                innerHTML: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003019')
              }
            }),
              h('span', {
                slot: "close",
                domProps: {
                  innerHTML: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003020')
                }
              })
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003045'),
          key: 'status',
          minWidth: 160,
          align: 'center',
          renderHeader: (h, params) => {
            return h("div", {class: "flex align-items-center"}, [
              h("span", aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003045')),
              h(
                "Tooltip",
                {
                  props: {
                    offset: 13,
                    transfer: true,
                    maxWidth: 250,
                    content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003040'),
                    placement: "top-end"
                  }
                },
                [
                  h("Icon", {
                    props: {
                      type: "ios-help-circle-outline",
                      size: 16
                    },
                    style: {
                      cursor: "pointer",
                      marginLeft: "5px"
                    }
                  })
                ]
              )
            ]);
          },
          render(h, params) {
            let talg = params.row.showModuleLocation === 1;
            return h('i-switch', {
              props: {
                value: talg,
                disabled: !v.getPermission('helpCenterDocs_enable') || !params.row.moduleId || !v.showStatusTalg,
              },
              attrs: {
                title: v.showStatusTalg ? '' : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003044')
              },
              on: {
                'on-change': (val) => {
                  v.updateStatusBtn(params.row, val, 'showModuleLocation');
                }
              }
            }, [h('span', {
              slot: "open",
              domProps: {
                innerHTML: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003019')
              }
            }),
              h('span', {
                slot: "close",
                domProps: {
                  innerHTML: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003020')
                }
              })
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003021'),
          key: 'firstShowStatus',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let talg = params.row.firstShowStatus === 1;
            return h('i-switch', {
              props: {
                value: talg,
                disabled: !v.getPermission('helpCenterDocs_enable') || !v.showStatusTalg
              },
              attrs: {
                title: v.showStatusTalg ? '' : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003044')
              },
              on: {
                'on-change': (val) => {
                  if (val) {
                    v.getRecommendStatus(params, val);
                  } else {
                    v.updateStatusBtn(params.row, val, 'firstShowStatus');
                  }
                }
              }
            }, [h('span', {
              slot: "open",
              domProps: {
                innerHTML: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003019')
              }
            }),
              h('span', {
                slot: "close",
                domProps: {
                  innerHTML: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003020')
                }
              })
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'opts',
          align: 'center',
          width: 220,
          render(h, params) {
            let title = params.row.title;
            let content = params.row.content;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003'),
                    show: v.getPermission('helpCenterDocs_insert'),
                    clickFn: () => {
                      v.copyArticleBtn(params.row.docsId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('helpCenterDocs_update'),
                    clickFn: () => {
                      v.editArticleBtn(params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: v.getPermission('helpCenterDocs_delete') && params.row.docsType === 0,
                    clickFn: () => {
                      v.deleteArticleBtn(params.row.categoryId, params.row.docsId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableColumns: []
    };
  },
  computed: {
    // 文档类型
    docsTypeList() {
      const ENUM_KEY = 'HelpCenterDocsDocsTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    }
  },
  created() {
    this.initData();
  },
  methods: {
    getEnumName,
    // 初始化数据
    async initData() {
      let enumKeyList = ['HelpCenterDocsDocsTypeCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.systemDefaultLanguage().then(() => {
        this.initContentInfoFields();
      });
      this.systemModuleList = getSystemModuleList(supplierMenu, '3');
      this.initMultilingualFields('catalogueForm', this.catalogueForm, ['name_']);
      this.userInfoList = await getAllUsersInfo();
      if (this.getPermission('helpCenterSector_list')) {
        await this.getSector();
      }
      this.getCatalogueTreeData(true);
    },
    onTabClick() {
      let obj = this.tabList.find(i => i.sectorId);
      this.treeTopId = obj.parentId;
      this.tableData = [];
      this.getCatalogueTreeData(true);
    },
    getSystemModuleName(moduleId) {
      let v = this;
      let system = v.getPlatformCode();
      let arr = [];
      if (system === 'ymsCore') {
        arr = findPathById(ymsMenu.menu, moduleId);
      } else if (system === 'ymsSupplier') {
        arr = findPathById(supplierMenu.menu, moduleId);
      } else if (system === 'ymsDistributor') {
        arr = findPathById(distributorMenu.menu, moduleId);
      }

      function findPathById(tree, targetId) {
        for (const node of tree) {
          if (node && node.menuKey && node.menuKey === targetId) {
            return [node];
          }
          if (node && node.children && node.children.length > 0) {
            const path = findPathById(node.children, targetId);
            if (path.length > 0) {
              return [node, ...path];
            }
          }
        }
        return [];
      }

      return arr.map(i => i.name).join('->');
    },
    async getSector() {
      const {data} = await this.axios.get(api.get_helpCenterSector_list);
      const {code, datas} = data;
      if (code === 0) {
        this.tabList = datas.map(i => {
          const list = i.internationalQueryResultList || [];
          // 先赋值
          list.forEach(j => {
            i[`${j.language}_name`] = j.name;
          });
          // 中文值
          const zhName = i['zh-CN_name'];
          // 如果没有英文，用中文兜底
          if (!i['en-US_name'] && zhName) {
            i['en-US_name'] = zhName;
          }
          return i;
        });
        if (datas.length > 0) {
          this.useTabValue = datas[0].sectorId;
          this.treeTopId = datas[0].parentId;
        }
      }
    },
    // 初始化多语种字段数据
    initContentInfoFields() {
      let obj = {};
      let copyObj = {};
      if (this.multilingualNamesList.length > 0) {
        this.multilingualNamesList.map((item) => {
          obj['title_' + item.code] = '';
          obj['content_' + item.code] = '';
          copyObj['copyTitle_' + item.code] = '';
          copyObj['copyContent_' + item.code] = '';
        });
        this.contentInfo = Object.assign({}, obj, {sort: 0, showStatus: true,});
        this.copyArticleForm = Object.assign({}, copyObj, {sort: 0, showStatus: true,});
      }
    },
    // 获取目录分类列表数据
    getCatalogueTreeData(value) {
      let v = this;
      this.contentTalg = false;
      if (v.getPermission('ymsHelpCategory_listBySectorId')) {
        v.catalogueList = [];
        v.axios.get(api.get_helpCenterCategory_listBySectorId, {params: {sectorId: v.useTabValue}}).then((response) => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            data.forEach(i => {
              i.id = i.categoryId;
            });
            if (data && data.length > 0) {
              v.catalogueList = v.handerData(data, value, v.treeTopId);
            }
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 判断首页推荐是否超过5个推荐
    getRecommendStatus(obj, val) {
      let v = this;
      v.axios.get(api.get_helpCenterDocs_listDocs, {
        params: {
          platformId: 'ymsDistributor',
        }
      }).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (val) {
            if (data.length >= 5) {
              setTimeout(() => {
                v.getArticleList(obj.row.categoryId);
              }, 200);
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003025'));
              v.$forceUpdate();
              return false;
            } else {
              v.updateStatusBtn(obj.row, val, 'firstShowStatus');
            }
          }
        }
      });
    },
    // 展示状态的更新
    updateStatusBtn(data, value, key) {
      let v = this;
      let query = {
        docsId: data.docsId,
        // "firstShowStatus": data.firstShowStatus, // "首页推荐 0否，1是  [integer]"
        // "showModuleLocation": data.showModuleLocation, // "所属模块处是否展示 0否，1是  [integer]"
        // "showStatus": data.showStatus, // "帮助中心处是否展示 0否，1是  [integer]"
      };
      query[key] = value ? 1 : 0;
      v.axios.put(api.put_helpCenterDocs_enable, query).then((response) => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          if (key) {
            data[key] = value ? 1 : 0;
          }
          v.getArticleList(data.categoryId);
        }
      });
    },
    // 选中目录
    selectCatalogue(data, item) {
      this.contentTalg = false;
      if (item.level === 3) {
        this.contentTalg = true;
        this.showStatusTalg = item.showStatus === 1;
        this.categoryId = item.categoryId;
        this.getArticleList(item.categoryId);
      }
      this.$forceUpdate();
    },
    reset() {
      this.pageParams.docsType = null;
      this.getArticleList(this.categoryId);
    },
    search() {
      this.pageParams.pageNum = 1;
      this.getArticleList(this.categoryId);
    },
    // 获取文章列表数据
    getArticleList(categoryId) {
      let v = this;
      v.tableData = [];
      if (v.getPermission('helpCenterDocs_query')) {
        v.tableLoading = true;
        let query = {
          categoryId: categoryId,
          pageSize: v.pageParams.pageSize,
          pageNum: v.pageParams.pageNum,
          docsType: v.pageParams.docsType,
          timeZoneOffset: 0
        };
        v.axios.post(api.post_helpCenterDocs_query, query).then((response) => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let newData = data.list || [];
              newData.forEach(i => {
                i.docsInternationalQueryResultList = fixCategoryLang(i.docsInternationalQueryResultList, 'title');
              });
              v.tableData = newData;
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = true;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 删除文章
    deleteArticleBtn(categoryId, id) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003026'),
        onOk: () => {
          v.axios.delete(api.delete_helpCenterDocs + id, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
              v.getArticleList(categoryId);
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 复制文章的确定按钮
    copyArticleBtn(docsId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003046'),
        onOk: async () => {
          const {data} = await this.axios.get(api.get_helpCenterDocs + docsId);
          const {code, datas} = data;
          if (code === 0) {
            let params = {
              "categoryId": v.categoryId,
              "docsId": datas.docsId,
              "docsInternationalParamBoList": datas.docsInternationalQueryResultList,
              "docsType": 0, // 文档类型 0是自建文档 1是官方文档
              "firstShowStatus": 0, // 首页推荐 0否，1是  [
              "moduleId": datas.moduleId,
              "showModuleLocation": datas.showModuleLocation, //  0否，1是
              "showPosition": datas.showPosition,
              "showStatus": datas.showStatus, //  0否，1是
              "sort": datas.sort
            };
            const response = await v.axios.post(api.post_helpCenterDocs, params);
            if (response.data.code === 0) {
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002172'));
              this.getArticleList(this.categoryId);
            }
          }
        },
        onCancel: () => {
        }
      });
    },
    // 监听复制文章的弹窗
    copyArticleModalChange(value) {
      if (!value) {
        this.$refs['copyArticleForm'].resetFields();
        this.initContentInfoFields();
        this.copyArticleForm.sort = 0;
        this.copyArticleForm.showStatus = true;
      }
    },
    // 取消新增、编辑文章
    cancelBtn() {
      let v = this;
      v.$refs['contentInfo'].resetFields();
      v.addContentTalg = false;
      v.initFinished = false;
      v.initContentInfoFields();
      v.contentInfo.showStatus = true;
      v.contentInfo.sort = 0;
    },
    // 预览
    previewBtn() {
      let v = this;
      let language = v.$refs['formLanguagesTab'].tabName;
      if (v.articleTalg === 'edit') {
        const {href} = v.$router.resolve({
          path: '/previewHelpCenter',
          query: {
            id: v.selectId,
            type: v.articleTalg,
            language: language
          }
        });
        let text = {
          title: v.contentInfo['title_' + language],
          content: v.$refs['ueBox_' + language][0].getUEContent()
        };
        localStorage.setItem('previewContent', JSON.stringify(text));
        setTimeout(() => {
          window.open(href, '_blank');
        }, 500);
      } else {
        const {href} = v.$router.resolve({
          path: '/previewHelpCenter',
          query: {
            id: v.categoryId,
            type: v.articleTalg,
            language: language
          }
        });
        let text = {
          title: v.contentInfo['title_' + language],
          content: v.$refs['ueBox_' + language][0].getUEContent()
        };
        localStorage.setItem('previewContent', JSON.stringify(text));
        setTimeout(() => {
          window.open(href, '_blank');
        }, 500);
      }
    },
    getPlatformCode() {
      let v = this;
      let obj = this.tabList.find((item) => item.sectorId === v.useTabValue);
      return obj ? obj.platformId : null;
    },
    // 新增内容
    addArticleBtn() {
      /*this.initContentInfoFields();
      this.addContentTalg = true;
      this.articleTalg = 'add';
      this.contentInfo.sort = this.total + 1;
      this.$nextTick(() => {
        this.$refs['formLanguagesTab'].tabName = this.languagesVal;
      });*/
      let v = this;
      let _platformId = v.getPlatformCode();
      v.$refs['editHelpDocsModalRef'].initGuideData('add', v.categoryId, _platformId);
    },
    // 编辑内容
    editArticleBtn(row) {
      let v = this;
      let _platformId = v.getPlatformCode();
      v.$refs['editHelpDocsModalRef'].initGuideData('edit', v.categoryId, _platformId, row);
    },
    // 新增、编辑文章保存按钮
    contentBtn() {
      let v = this;
      let url = '';
      let query = {
        title: v.contentInfo['title_CN'],
        conent: v.$refs['ueBox_CN'][0].getUEContent(),
        sort: v.contentInfo.sort,
        showStatus: v.contentInfo.showStatus === true ? 1 : 0,
        helpDocInternationalList: []
      };
      let axiosType = v.catalogueType === 'add' ? 'post' : 'put';
      if (v.articleTalg === 'add') {
        url = api.post_helpCenterDocs;
        query.categoryId = v.categoryId;
        query.isFirst = 0;
      } else {
        url = api.put_helpCenterDocs;
        query.id = v.selectId;
        query.categoryId = v.categoryId;
        query.originalSort = v.originalSort;
      }
      let list = [];
      for (let key in v.contentInfo) {
        if (key.includes('_')) {
          let code = key.split('_')[1];
          list.push(code);
        }
      }
      if (list.length > 0) {
        list.map((key) => {
          let ueBoxDom = v.$refs['ueBox_' + key];
          if (v.contentInfo['title_' + key]) {
            query.helpDocInternationalList.push({
              content: ueBoxDom[0].getUEContent(),
              language: key,
              title: v.contentInfo['title_' + key],
            });
          }
        });
        query.helpDocInternationalList = v.uniqueFunc(query.helpDocInternationalList, 'language');
      }
      v.$refs['contentInfo'].validate((valid) => {
        if (valid) {
          v.axios[axiosType](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
              v.articleTalg = 'add';
              v.cancelBtn();
              v.getArticleList(v.categoryId);
            }
          });
        }
      });
    },
    // 删除子目录
    deleteBtn(data) {
      let v = this;
      let name = data.name;
      let categoryInternational = data.internationalQueryResultList || [];
      if (categoryInternational.length > 0) {
        categoryInternational.map((item) => {
          if (item.language === v.languagesVal) {
            name = item.name;
          }
        });
      }
      v.$Modal.confirm({
        title: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003013')}${name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003014')}`,
        onOk: () => {
          v.axios.delete(api.delete_helpCenterCategory + data.categoryId, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
              v.getCatalogueTreeData();
            } else {
              return false;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 新增、重命名目录按钮
    optionsBtn(type, data) {
      this.level = data.level;
      this.selectData = data;
      if (type === 'add') {
        this.catalogueTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003022');
        this.catalogueType = 'add';
        this.selectId = data.categoryId;
      } else {
        this.catalogueType = 'edit';
        this.catalogueTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003027');
        this.selectId = data.categoryId;
        let categoryInternational = data.internationalQueryResultList || [];
        if (categoryInternational.length > 0) {
          categoryInternational.map((item) => {
            this.catalogueForm['name_' + item.language] = item.name;
          });
        } else {
          let obj = this.handleMultilingualFormFields(data, ['name']);
          this.catalogueForm = Object.assign({}, this.catalogueForm, obj);
        }
      }
      this.$nextTick(() => {
        this.$refs['languagesTab_catalogue'].tabName = this.languagesVal;
        this.getFocus('directoryName_' + this.languagesVal);
      });
      this.catalogueModal = true;
    },
    // 新增、重命名目录的确定按钮
    catalogueBtn() {
      let v = this;
      let url = '';
      let query = {
        name: v.catalogueForm['name_CN'],
        internationalParamBoList: [],
        // categoryType: 0,
        sectorId: v.useTabValue
      };
      let axiosType = v.catalogueType === 'add' ? 'post' : 'put';
      if (v.catalogueType === 'add') {
        url = api.post_helpCenterCategory;
        query.parentCategoryId = v.selectId;
      } else {
        url = api.put_helpCenterCategory;
        query.categoryId = v.selectId;
      }
      for (let key in v.catalogueForm) {
        if (v.catalogueForm[key]) {
          query.internationalParamBoList.push({
            language: key.split('name_')[1],
            name: v.catalogueForm[key],
          });
        }
      }
      query.categoryType = 0;

      v.$refs['catalogueForm'].validate((valid) => {
        if (valid) {
          v.axios[axiosType](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
              if (v.catalogueType === 'add') {
                v.categoryId = response.data.datas;
              } else {
                v.categoryId = v.selectId;
              }
              v.getCatalogueTreeData();
              v.catalogueModal = false;
            }
          });
        }
      });
    },
    // 监听新增、编辑目录弹窗
    catalogueModalChange(value) {
      let v = this;
      if (value) {
        v.$refs['languagesTab_catalogue'].tabName = v.languagesVal;
        v.$nextTick(() => {
          v.getFocus('directoryName_' + v.languagesVal);
        });
        v.$forceUpdate();
      } else {
        v.catalogueTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003022');
        v.catalogueType = 'add';
        v.selectId = null;
        v.$refs['catalogueForm'].resetFields();
      }
    },
    // 处理目录分类数据
    handerData(data, value, topId) {
      let v = this;
      if (data) {
        data = data.sort((a, b) => {
          return a.sort - b.sort;
        });
        data.forEach((item) => {
          item.internationalQueryResultList = fixCategoryLang(item.internationalQueryResultList, 'name');
          let obj = (item.internationalQueryResultList || []).find(i => i.language === v.languagesVal);
          item.title = obj ? obj.name : item.name;
        });
        let newData = data.filter((item) => {
          let child = data.filter((ele) => {
            return item.categoryId === ele.parentCategoryId;
          });
          if (child.length > 0) {
            item.children = child;
          }
          return item.parentCategoryId === topId;
        });

        function handleData(newData) {
          if (newData[0].children) {
            if (newData[0].children[0].children) {
              let item = newData[0].children[0].children[0];
              item['selected'] = true;
              v.contentTalg = true;
              v.showStatusTalg = item.showStatus === 1;
              v.categoryId = item.categoryId;
              v.getArticleList(item.categoryId);
            }
          }
        }

        if (newData.length > 0) {
          // 默认选中第一个文章
          if (value) {
            handleData(newData)
          } else {
            if (v.categoryId) {
              data.map((item) => {
                if (item.categoryId === v.categoryId) {
                  item['selected'] = true;
                  if (v.level === 3) {
                    v.contentTalg = true;
                    v.showStatusTalg = item.showStatus === 1;
                    v.getArticleList(item.categoryId);
                  } else {
                    v.contentTalg = false;
                  }
                  v.categoryId = item.categoryId;
                }
              });
            } else {
              handleData(newData)
            }
          }

          const recursive = (array, level = 0) => {
            level++;
            return array.map(item => {
              item['level'] = level;
              const child = item.children;
              if (child && child.length) recursive(child, level);
              return item;
            });

          };
          data.map((item) => {
            let categoryInternational = item.internationalQueryResultList || [];
            let list = categoryInternational.filter((ele) => {
              return ele.language === v.languagesVal;
            });
            item['title'] = list.length > 0 ? list[0].name : item.name;
            item.expand = true;
            item.render = (h, {root, node, data}) => {
              // 操作按钮
              let options = h('div', {
                  style: {
                    display: 'none',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    width: '80px'
                  },
                  class: 'options_boxs'
                },
                [
                  // 新增
                  item.level !== 3 && v.getPermission('ymsHelpCategory_insert') ? h('Icon', {
                    props: {
                      type: 'ios-add-circle-outline',
                      color: '#1BD90F'
                    },
                    style: {
                      fontSize: '18px',
                      marginRight: '6px',
                      cursor: 'pointer'
                    },
                    on: {
                      'click'(e) {
                        e.stopPropagation();
                        v.optionsBtn('add', data);
                      }
                    }
                  }) : '',
                  // 展示与隐藏
                  item.level !== 1 ? h('Icon', {
                    props: {
                      type: item.showStatus === 1 ? 'ios-eye-outline' : 'ios-eye-off-outline',
                      color: '#2D8CF0'
                    },
                    attrs: {
                      title: item.showStatus === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002383') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003047')
                    },
                    style: {
                      fontSize: '22px',
                      marginRight: '10px',
                      cursor: 'pointer',
                      position: 'relative',
                      left: '3px'
                    },
                    on: {
                      'click'(e) {
                        e.stopPropagation();
                        v.showAndHideBtn(item)
                      }
                    }
                  }) : '',
                  // 重命名
                  item.level !== 1 && item.categoryType !== 1 && v.getPermission('ymsHelpCategory_update') ? h('Icon', {
                    props: {
                      type: 'ios-create-outline',
                      color: '#2D8CF0'
                    },
                    style: {
                      fontSize: '20px',
                      marginRight: '6px',
                      cursor: 'pointer',
                      position: 'relative',
                      left: '3px'
                    },
                    on: {
                      'click'(e) {
                        e.stopPropagation();
                        v.optionsBtn('edit', data);
                      }
                    }
                  }) : '',
                  // 删除
                  item.parentCategoryId !== topId && item.categoryType !== 1 && v.getPermission('ymsHelpCategory_delete') ? h('Icon', {
                    props: {
                      type: 'ios-trash-outline',
                      color: '#EB1818'
                    },
                    style: {
                      fontSize: '21px',
                      marginRight: '6px',
                      cursor: 'pointer'
                    },
                    on: {
                      'click'(e) {
                        e.stopPropagation();
                        v.deleteBtn(data);
                      }
                    }
                  }) : ''
                ]);
              return h('div', {
                  class: 'flex align-items-center justify-content-between options_boxs_item',
                  domProps: {
                    draggable: item.parentCategoryId !== topId
                  },
                  on: {
                    // 拖拽开始
                    dragstart: (e) => {
                      e.stopPropagation();
                      const {target} = e;
                      target.style.opacity = '.5';
                      READY_TO_APPEND = data;
                    },
                    dragover: (e) => {
                      e.preventDefault();
                      if (READY_TO_APPEND === data) {
                        APPEND_TARGET = null;
                        return;
                      }
                      const {offsetY, target} = e;
                      const offset = offsetY / target.offsetHeight;
                      if (offset <= 0.33) {
                        APPEND_TO = APPEND_BEFORE;
                      } else if (offset > 0.33 && offset < 0.66) {
                        APPEND_TO = APPEND_INNER;
                      } else if (offset >= 0.66) {
                        APPEND_TO = APPEND_AFTER;
                      }
                      this.setBorderOffsetElement(target);
                      APPEND_TARGET = data;
                    },
                    //把拖拽元素从父节点中删除
                    dragend: (e) => {
                      e.preventDefault();
                      const {target} = e;
                      this.clearBorder();
                      target.style.opacity = '1';
                      if (!APPEND_TARGET || this.isChildren(data, APPEND_TARGET)) {
                        return;
                      }
                      // 从树上移除节点，就是拖动的节点
                      const removeNode = () => {
                        let parentDom = root.find(el => el.children && el.children.indexOf(data.nodeKey) > -1);
                        if (parentDom) {
                          const parent = parentDom.node;
                          const index = parent.children.indexOf(data);
                          parent.children.splice(index, 1);
                        }
                      };
                      removeNode();

                      // 把移除的节点根据前后位置及父级关系添加回去
                      const doAppend = (isBefore) => {
                        let parentDom = root.find(el => el.children && el.children.indexOf(APPEND_TARGET.nodeKey) > -1);
                        if (parentDom) {
                          const parent = parentDom.node;
                          PARENT_DATA = parentDom.node;
                          const index = parent.children.indexOf(APPEND_TARGET) + (isBefore ? 0 : 1);
                          parent.children.splice(index, 0, data);
                          if (parent.children.length === 0) {
                            delete parent.children;
                          }
                        }
                      };

                      switch (APPEND_TO) {
                        case APPEND_BEFORE:
                          doAppend(true);
                          break;
                        case APPEND_AFTER:
                          doAppend(false);
                          break;
                        case APPEND_INNER:
                          // 先展开
                          this.$set(APPEND_TARGET, 'expand', true);
                          // 加载内容
                          this.buildChild(APPEND_TARGET, data);
                          break;
                      }
                      v.updateDirectorySorting(data, APPEND_TARGET, APPEND_TO, PARENT_DATA);
                    },
                  }
                },
                [
                  h('div', {class: 'flex align-items-center'}, [
                    h('div', {
                      style: {
                        maxWidth: '170px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        wordWrap: 'break-word',
                        wordBreak: 'break-all'
                      },
                      attrs: {
                        title: data.title,
                      }
                    }, data.title),
                    data.showStatus === 0 ? h('div', {class: 'ml5 redColor'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003048')) : ''
                  ]),
                  options
                ]);
            };
          });

          return recursive(newData);
        }
      }
    },
    // 拖拽目录排序后，重新更新目录数据
    updateDirectorySorting(from, to, position, parentData) {
      console.log('++++===拖拽结束===', 'form----', from, 'to====', to, 'position-----', position, '-parentData---', parentData);
      let v = this;
      v.handerHierarchy(from, to, position, parentData).then((res) => {
        if (res) {
          let preCategoryId = null;
          let pId = null;
          if (parentData) {
            pId = parentData.id;
            if (parentData.parentCategoryId !== v.treeTopId) {
              parentData.children.map((item, index) => {
                if (item.id === from.id) {
                  preCategoryId = parentData.children[index - 1] ? parentData.children[index - 1].id : null;
                }
              });
            } else {
              parentData.children.map((ele, idx) => {
                if (ele.id === from.id) {
                  preCategoryId = parentData.children[idx - 1] ? parentData.children[idx - 1].id : null;
                }
              });
            }
          } else {
            if (position === 'inner') {
              pId = to.id;
            }
          }
          let query = {
            parentCategoryId: pId,
            categoryId: from.id,
            preCategoryId: preCategoryId,
            dataSource: 'yms'
          };
          v.axios.post(api.post_helpCenterCategory_updateCategorySort, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.catalogueModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
              v.categoryId = from.id;
              v.level = from.level;
              v.getCatalogueTreeData();
              READY_TO_APPEND = null;
              APPEND_TO = null;
              APPEND_TARGET = null;
              PARENT_DATA = null;
            }
          });
        } else {
          READY_TO_APPEND = null;
          APPEND_TO = null;
          APPEND_TARGET = null;
          PARENT_DATA = null;
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003028'));
          v.getCatalogueTreeData();
          return false;
        }
      });
    },
    // 限制层级关系最多只能有三个层级
    handerHierarchy(from, to, position, parentData) {
      let talg = true;
      let v = this;
      return new Promise((resolve) => {
        if (from.level === 3 && to.level === 3) {
          talg = !(to.children && to.children.length > 0);
        } else if (from.level === 2 && to.level === 2) {
          talg = !(position === 'inner' && !parentData);
        }
        if (!from.children && !to.children && from.level === 3 && to.level === 3) {
          talg = true;
        }
        if (parentData && parentData.parentCategoryId === v.treeTopId && position === 'inner') {
          for (let i = 0; i < parentData.children.length; i++) {
            let item = parentData.children[i];
            if (item.level === 3) {
              talg = false;
            }
          }
        }
        if (from.level === 3 && to.level === 2) {
          if (to.children && to.children.length > 0) {
            talg = true;
            to.children.map((item) => {
              talg = item.id === from.id;
              if (item.children && item.children.length > 0) {
                talg = false;
              }
            });
          } else {
            talg = false;
          }
        }
        if (from.level === 2 && to.level === 3) {
          if (from.children && from.children.length > 0) {
            talg = false;
          }
          if (to.children && to.children.length > 0) {
            talg = false;
          }
        }
        if (to.parentCategoryId === v.treeTopId) {
          talg = false;
        }
        resolve(talg);
      });
    },
    setBorderOffsetElement(target) {
      this.clearBorder();
      let ul = target;
      while (ul.className !== TREE_NODE_CLASS) {
        ul = ul.parentElement;
      }
      ul.className = `${TREE_NODE_CLASS} ${TREE_NODE_HOVER_PREFIX}${APPEND_TO}`;
    },
    clearBorder() {
      let temp = document.querySelectorAll(`
        .${TREE_NODE_HOVER_PREFIX}${APPEND_BEFORE},
        .${TREE_NODE_HOVER_PREFIX}${APPEND_INNER},
        .${TREE_NODE_HOVER_PREFIX}${APPEND_AFTER}
      `);
      for (let i = 0; i < temp.length; i++) {
        temp[i].className = TREE_NODE_CLASS;
      }
    },
    async buildChild(node, child) {
      if (node.loading === void (0)) {
        if (child) {
          if (node.children) {
            if (node.children.length > 0) {
              node.children.push(child);
              return;
            }
          } else {
            this.$set(node, 'children', [child]);
            return;
          }
        }
        return;
      }
      this.$set(node, 'loading', true);
      // 接口获取数据加载子节点
      const data = (await this.catalogueList) || [];
      if (child) {
        data.push(child);
      }
      if (data.length) {
        this.$set(node, 'children', data);
        this.$set(node, 'expand', true);
      } else {
        this.$delete(node, 'children');
      }
      this.$delete(node, 'loading');
    },
    isChildren(node, child) {
      const {children} = node;
      if (!children || !children.map) return false;
      let flag = children.some(c => c.nodeKey === child.nodeKey);
      if (!flag) {
        children.map(node => {
          flag = this.isChildren(node, child);
        });
      }
      return flag;
    },
    // 设置表单必填项校验规则
    getRules(item) {
      let list = [];
      if (item.required) {
        list = [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003024') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002427'), trigger: 'blur'}
        ];
      }
      return list;
    },
    getCopyRules(item) {
      let list = [];
      if (item.required) {
        list = [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003015') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002427'), trigger: 'blur'}
        ];
      }
      return list;
    },
    getFormRules(item) {
      let list = [];
      if (item.required) {
        list = [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003029') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000904'), trigger: 'blur'}
        ];
      }
      return list;
    },
    // 切换多语种tabs
    changeLanguagesTabs(name) {
      let v = this;
      v.initEditorFun(name);
    },
    // 初始化富文本编辑器
    initEditorFun(name) {
      let v = this;
      v.$nextTick(() => {
        let editor = v.$refs['ueBox_' + name][0].editor;
        let userInfo = v.$store.state.erpConfig.userInfo;
        if (editor) {
          editor.addListener('ready', function () {
            editor.execCommand('serverparam', {
              'basePath': 'yms-core-service',
              'userId': userInfo.merchantId + ',' + userInfo.userId
            });
          });
          // 切换Tab的时候，手动触发 ready 事件
          if (name === 'US') {
            editor.fireEvent('ready');
          }
        }
        setTimeout(() => {
          v.getFocus('contentTitle_' + name);
        }, 800);
      });
    },
    updateData() {
      this.getArticleList(this.categoryId);
    },
    // 展示与隐藏类目
    showAndHideBtn(item) {
      let v = this;
      let query = {
        categoryId: item.categoryId,
        showStatus: item.showStatus === 1 ? 0 : 1
      }
      v.level = item.level;
      v.axios.put(api.put_helpCenterCategory_updateShowStatus, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.getCatalogueTreeData();
        }
      });
    },
    // 处理列表字段
    handleColumns(value) {
      let obj = this.tabList.find(item => item.sectorId === value);
      if (obj && obj.platformId !== 'ymsDistributor') {
        this.tableColumns = this.originalColumns.filter(i => !['firstShowStatus'].includes(i.key));
      } else {
        this.tableColumns = this.originalColumns;
      }
    },
  },
  watch: {
    initFinished: {
      handler(value) {
        let v = this;
        if (value) {
          v.initEditorFun(v.languagesVal);
        }
      },
      immediate: true,
      deep: true
    },
    addContentTalg: {
      handler(value) {
        if (!value) {
          this.cancelBtn();
        } else {
          this.initFinished = true;
        }
      }
    },
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        this.getArticleList(this.categoryId);
        v.pageParamsStatus = false;
      }
    },
    useTabValue: {
      handler(value) {
        this.handleColumns(value);
      },
      immediate: true,
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem('previewContent');
    next();
  },
  components: {
    languagesTabs,
    editHelpDocsModal,
    UE
  }
};
</script>

<style lang="less" scoped>
.help_center_box {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .catalogue_box {
    width: 20%;
    height: 760px;
    background-color: #fff;
    min-width: 328px;
    margin-right: 15px;
    box-sizing: border-box;

    /deep/ .catalogue_box_tree {
      padding: 10px 15px;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
    }

    /deep/ .ivu-tree-title {
      width: 100%;
      box-sizing: border-box;

      .options_boxs_item {
        height: 32px;
        position: relative;
      }

      &:hover {
        .options_boxs {
          display: flex !important;
        }
      }
    }

    /deep/ .ivu-tree ul {
      li {
        margin: 0;

        .ivu-tree-arrow {
          position: relative;
          top: 5px;
        }
      }

      .ivu-tree-title-selected {
        color: #2d8cf0;
        background-color: #f0faff !important;

        .options_boxs_item:after {
          content: '';
          display: block;
          width: 2px;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          background: #2d8cf0;
        }
      }
    }

    /deep/ .tree-hover-before {
      border-top: 2px solid #2d8cf0 !important;
    }

    /deep/ .tree-hover-inner {
      background-color: #f0faff;

      span {
        color: #fff;
      }
    }

    /deep/ .tree-hover-after {
      border-bottom-color: #2d8cf0 !important;
    }

    .catalogue_box_item {
      height: 35px;
      line-height: 35px;

      .catalogue_title_box {
        .options_boxs {
          display: none;
        }

        &:hover {
          color: #2d8cf0;
          background-color: rgba(230, 247, 255, 1);

          .options_boxs {
            display: inline-block;
          }
        }
      }

      .catalogue_list {
        padding-left: 10px;

        .catalogue_list_box {
          color: #666;
          font-size: 14px;
          height: 35px;
          line-height: 35px;

          .catalogue_list_item {
            .options_boxs {
              display: none;
            }

            &:hover {
              color: #2d8cf0;
              background-color: rgba(230, 247, 255, 1);

              .options_boxs {
                display: inline-block;
              }
            }
          }
        }
      }

      .opts_btn {
        font-size: 13px;
        cursor: pointer;
        display: inline-block;
      }

      .catalogue_title {
        font-weight: bold;
        color: #333;
        font-size: 15px;
        padding: 0 10px;
        width: 235px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-wrap: break-word;
        word-break: break-all;
      }

      .catalogue_text {
        color: #666;
        font-size: 14px;
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-wrap: break-word;
        word-break: break-all;
        cursor: move;
      }
    }
  }

  .content_box {
    background-color: #fff;
    padding: 15px;
    width: 79%;
    min-width: 857px;
    box-sizing: border-box;
    height: 760px;
    overflow-x: auto;

    .editor_style {
      /deep/ .ivu-form-item-content {
        line-height: initial !important;
      }
    }
  }
}
</style>
